import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';


export class ChPaginationComponent {
   total = 0;
   pageIndex = 1;
   preLink = '«';
   nextLink = '»';
   pageSize = 10;
   size: string;
   changePageIndex = new EventEmitter<any>();
  count = 5;
  showPages = [];
  totalPage: number;

  ngOnChanges() {
    this.pageIndex = Number(this.pageIndex);
    this.totalPage = this.getPageTotal();
    this.createPageArray();
  }

  skipPre() {
    if (this.hasPre) {
      this.pageIndex = this.pageIndex - 1;
      this.createPageArray();
      this.onChangePageIndex(this.pageIndex);
    }
  }

  skipNext() {
    if (this.hasNext) {
      this.pageIndex = this.pageIndex + 1;
      this.createPageArray();
      this.onChangePageIndex(this.pageIndex);
    }
  }

  selectPage(page) {
    if (this.pageIndex !== page) {
      this.pageIndex = page;
      this.createPageArray();
      this.onChangePageIndex(this.pageIndex);
    }

  }

  onChangePageIndex(page) {
      this.changePageIndex.emit(page);
  }

  createPageArray() {
    const index = this.pageIndex;
    if (this.totalPage < this.count) {
      this.showPages = new Array<number>(this.totalPage).fill(0).map((_a, i) => i + 1);
      return;
    }
    this.showPages = this.getPagesRange();
  }

  getPagesRange() {
    const showPages = [this.pageIndex];
    let star = this.pageIndex - 1;
    let ent = this.pageIndex + 1;

    const leftRange = index => index < 1;
    const rightRange = index => index > this.totalPage;
    const pagesLengthRange = len => len.length >= this.count;

    while (!pagesLengthRange(showPages)) {
      if (!leftRange(star)) {
        showPages.unshift(star--);
      }

      if (!rightRange(ent)) {
        showPages.push(ent++);
      }
    }

    return showPages;
  }

  getPageTotal() {
    return Math.ceil(this.total / this.pageSize);
  }

  hasPre() {
    return this.pageIndex > 1;
  }

  hasNext() {
    return this.pageIndex < this.totalPage;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ch-pagination',
  template: "\n    <ul class=\"pagination {{size? 'pagination-' + size : '' }}\"><li *ngIf=\"pageIndex > 1\" (click)=\"skipPre()\"><a><span>{{preLink}}</span></a></li><li *ngIf=\"showPages[showPages.length - 1] > count\" (click)=\"selectPage(1)\"><a>1</a></li><li class=\"disabled\" *ngIf=\"showPages[showPages.length - 1] > count\"><a>...</a></li><li *ngFor=\"let item of showPages\" [ngClass]=\"{'active': item == pageIndex}\" (click)=\"selectPage(item)\"><a>{{item}}</a></li><li class=\"disabled\" *ngIf=\"showPages[showPages.length - 1] < totalPage\"><a>...</a></li><li *ngIf=\"pageIndex < totalPage\" (click)=\"skipNext()\"><a><span>{{nextLink}}</span></a></li></ul>\n  ",
  styles: ["\n\n  "]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'total': [{ type: Input },],
'pageIndex': [{ type: Input },],
'preLink': [{ type: Input },],
'nextLink': [{ type: Input },],
'pageSize': [{ type: Input },],
'size': [{ type: Input },],
'changePageIndex': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
